import { render, staticRenderFns } from "./AddVendorForm.vue?vue&type=template&id=c248bf52&scoped=true&"
import script from "./AddVendorForm.vue?vue&type=script&lang=js&"
export * from "./AddVendorForm.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorForm.vue?vue&type=style&index=0&id=c248bf52&prod&lang=scss&scoped=true&"
import style1 from "./AddVendorForm.vue?vue&type=style&index=1&id=c248bf52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c248bf52",
  null
  
)

export default component.exports